import { ROUTE_REVEAL_COLLECTIONS } from "@/constants/routes";
import { createRouteFromParams } from "@/src/helpers/createRouteWithParams";
import useCanCurrentUserRevealProduct from "./useCanCurrentUserRevealProduct";

const useRevealLinkForProductCard = (
  collectionSlug: string,
  ownedBy: string,
) => {
  const currentUserCanReveal = useCanCurrentUserRevealProduct(
    collectionSlug,
    ownedBy,
  );
  return currentUserCanReveal
    ? createRouteFromParams(ROUTE_REVEAL_COLLECTIONS, {
        collectionName: collectionSlug,
      })
    : undefined;
};

export default useRevealLinkForProductCard;
